// extracted by mini-css-extract-plugin
export default {"loader":"oRGLEDqS","container":"q3a75Vuu"};